import { render, staticRenderFns } from "./environments_app_skeleton_loader.vue?vue&type=template&id=0f4159b6"
import script from "./environments_app_skeleton_loader.vue?vue&type=script&lang=js"
export * from "./environments_app_skeleton_loader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports